import React, { useState } from "react";
import Recently_added_dropdown from "../dropdown/recently_added_dropdown";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
// import "react-accessible-accordion/dist/fancy-example.css";
import { useDispatch, useSelector } from "react-redux";
import Collection_category_filter_details from "./collection_category_filter_details";
import {
  updatetrendingProperties,
  singleNftSearch,
  openColFilterMenu,
  updatetrendiPriceRange,
} from "../../redux/marketplaceSlice";
import { Button } from "@material-tailwind/react";
import ToggleBtn from "../ToggleBtn";

const Collection_category_filter = ({ collectionInfo }) => {
  const [currencyValFrom, setCurrencyValFrom] = useState();
  const [currencyValTo, setCurrencyValTo] = useState();
  const [propertiesModal, setPropertiesModal] = useState(false);
  const [propetiesAccordionValue, setPropetiesAccordionValue] = useState(null);
  const [selectedTraits, setSelectedTraits] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const dispatch = useDispatch();
  const { trendingCategoryItemData, openCollectionFilterModal } = useSelector(
    (state) => state.marketplace
  );

  const handlePropartiesAccordion = (parentId, e) => {
    setPropetiesAccordionValue(parentId);
    const target = e.target.closest(".accordion-item");
    target.classList.toggle("show-accordion");
  };

  const sortText = [
    {
      id: 1,
      text: "Price: Low to High",
    },
    {
      id: 2,
      text: "Price: high to low",
    },
  ];
  const blockchainText = [
    {
      id: 1,
      text: "Ethereum",
    },
    {
      id: 2,
      text: "Polygon",
    },
    {
      id: 3,
      text: "Flow",
    },
    {
      id: 4,
      text: "Tezos",
    },
  ];
  const categoryText = [
    {
      id: 1,
      text: "All",
    },
    {
      id: 2,
      text: "Art",
    },
    {
      id: 3,
      text: "Collectibles",
    },
    {
      id: 4,
      text: "Domain",
    },
    {
      id: 5,
      text: "Music",
    },
    {
      id: 6,
      text: "Photography",
    },
    {
      id: 7,
      text: "Virtual World",
    },
  ];
  const saleTypeText = [
    {
      id: 1,
      text: "Timed auction",
    },
    {
      id: 2,
      text: "Fixed price",
    },
    {
      id: 3,
      text: "Not for sale",
    },
    {
      id: 4,
      text: "Open for offers",
    },
  ];
  const propertiesText = [
    {
      parentId: 1,
      titleText: "Background",
      properties: [
        {
          id: 1,
          color: "red",
          point: "14",
        },
        {
          id: 2,
          color: "green",
          point: "56",
        },
        {
          id: 3,
          color: "blue",
          point: "11",
        },
        {
          id: 4,
          color: "white",
          point: "25",
        },
      ],
    },
    {
      parentId: 2,
      titleText: "Eyes",
      properties: [
        {
          id: 1,
          color: "red",
          point: "14",
        },
        {
          id: 2,
          color: "green",
          point: "56",
        },
        {
          id: 3,
          color: "blue",
          point: "11",
        },
        {
          id: 4,
          color: "white",
          point: "25",
        },
      ],
    },
    {
      parentId: 3,
      titleText: "face",
      properties: [
        {
          id: 1,
          color: "red",
          point: "14",
        },
        {
          id: 2,
          color: "green",
          point: "56",
        },
        {
          id: 3,
          color: "blue",
          point: "11",
        },
        {
          id: 4,
          color: "white",
          point: "25",
        },
      ],
    },
  ];

  const filterOpen = () => {
    setPropertiesModal(true);
    dispatch(openColFilterMenu());

    console.log(openCollectionFilterModal);
  };

  const propertiesFilterAll = () => {
    const filterData = trendingCategoryItemData;
    dispatch(
      updatetrendingProperties({ ...trendingCategoryItemData, filterData })
    );
  };

  const propertiesFilterHandle = () => {
    if (selectedTraits.length <= 0) return propertiesFilterAll();
    const filterData = [];
    const temp = {};
    temp = Object.assign(temp, trendingCategoryItemData);

    for (var key in temp) {
      for (let j = 0; j < selectedTraits.length; j++) {
        if (
          (temp[key]?.marketplace == "nut" &&
            temp[key]?.metadata
              .toLowerCase()
              .includes(selectedTraits[j].toLowerCase())) ||
          (temp[key]?.marketplace == "pallet" &&
            JSON.stringify(temp[key]?.traits)
              .toLowerCase()
              .includes(selectedTraits[j].toLowerCase()))
        ) {
          filterData.push(temp[key]);
        }
      }
    }
    console.log("propertiesFilter: ", filterData.length);

    dispatch(
      updatetrendingProperties({ ...trendingCategoryItemData, filterData })
    );
    dispatch(
      updatetrendiPriceRange({
        ...trendingCategoryItemData,
        currencyValFrom,
        currencyValTo,
      })
    );
  };
  const applyPriceFeature = () => {
    dispatch(
      updatetrendiPriceRange({
        ...trendingCategoryItemData,
        currencyValFrom,
        currencyValTo,
      })
    );
  };

  const singleNFTSearchInput = (e) => {
    dispatch(singleNftSearch(e));
  };

  const handleAccordionChange = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const getArrowRotation = (index) => {
    return activeIndex === index ? "rotate-180" : "";
  };

  const handleCurrencyValTo = (e) => {
    const value = e.target.value;
    console.log(value);
    if (value < 0) {
      setCurrencyValTo(0);
    } else {
      setCurrencyValTo(value);
    }
  };
  const handleCurrencyValFrom = (e) => {
    const value = e.target.value;
    if (value < 0) {
      setCurrencyValFrom(0);
    } else {
      setCurrencyValFrom(value);
    }
  };

  return (
    <>
      {/* <!-- Filter --> */}
      <div className="mb-8 flex flex-wrap items-center justify-between">
        <div className="flex flex-wrap items-center">
          {/* <!-- Blockchain --> */}

          {/* <Recently_added_dropdown data={blockchainText} dropdownFor="blockchain" /> */}

          {/* <!-- Category --> */}

          {/* <Recently_added_dropdown data={categoryText} dropdownFor="category" /> */}

          {/* <!-- Properties --> */}
          <div className="my-1 mr-2.5 relative">
            <button
              className="group dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
              onClick={filterOpen}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                className="fill-jacarta-700 dark:fill-jacarta-100 mr-1 h-4 w-4 transition-colors group-hover:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M6.17 18a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2v-2h4.17zm6-7a3.001 3.001 0 0 1 5.66 0H22v2h-4.17a3.001 3.001 0 0 1-5.66 0H2v-2h10.17zm-6-7a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2V4h4.17z"></path>
              </svg>
              <span>Properties</span>
            </button>

            {/* <!-- Properties Modal --> */}
            <div
              className={
                openCollectionFilterModal
                  ? "modal fade show block  absolute w-full z-10 top-20 overflow-visible PropertiesModal"
                  : "modal fade"
              }
              id="propertiesModal"
            >
              <div className="modal-dialog max-w-md h-full">
                <div className="modal-content ">
                  <div className="modal-header">
                    <h5 className="modal-title" id="propertiesModalLabel">
                      Properties
                    </h5>
                    {/* <button
                      type="button"
                      className="btn-close"
                      onClick={() => setPropertiesModal(false)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="fill-jacarta-700 h-6 w-6 dark:fill-white"
                      >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"></path>
                      </svg>
                    </button> */}
                  </div>

                  {/* <!-- Body --> */}
                  <div className="modal-body">
                    {/* Dropdown start */}
                    <Accordion
                      onChange={handleAccordionChange}
                      allowZeroExpanded
                    >
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton className="flex items-center justify-between w-full px-4 py-2 border-b border-gray-300 focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-50">
                            <span>Action Type</span>
                            <svg
                              className={`w-4 h-4 transform transition-transform ${getArrowRotation(
                                1
                              )}`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel className="px-4 py-2">
                          {/* Action Type*/}
                          <div className=""></div>
                        </AccordionItemPanel>
                      </AccordionItem>

                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton className="flex items-center justify-between w-full px-4 py-2 border-b border-gray-300 focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-50">
                            <span>Price</span>
                            <svg
                              className={`w-4 h-4 transform transition-transform ${getArrowRotation(
                                1
                              )}`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel className="px-4 py-2">
                          {/* Price Range*/}
                          <div className="flex items-center space-x-3 px-5 pb-2">
                            <input
                              type="number"
                              placeholder="From"
                              value={currencyValFrom}
                              onChange={(e) => handleCurrencyValFrom(e)}
                              className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full max-w-[7.5rem] rounded-lg border py-[0.6875rem] px-4 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                            />
                            <input
                              type="number"
                              placeholder="To"
                              value={currencyValTo}
                              onChange={(e) => handleCurrencyValTo(e)}
                              className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full max-w-[7.5rem] rounded-lg border py-[0.6875rem] px-4 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                            />
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>

                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton className="flex items-center justify-between w-full px-4 py-2 border-b border-gray-300 focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-50">
                            <span>Rarity Rank</span>
                            <svg
                              className={`w-4 h-4 transform transition-transform ${getArrowRotation(
                                1
                              )}`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel className="px-4 py-2">
                          {/* Price Range*/}
                          <div className="flex items-center space-x-3 px-5 pb-2">
                            <input
                              type="number"
                              placeholder="From"
                              // value={currencyValFrom}
                              // onChange={(e) => handleCurrencyValFrom(e)}
                              className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full max-w-[7.5rem] rounded-lg border py-[0.6875rem] px-4 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                            />
                            <input
                              type="number"
                              placeholder="To"
                              // value={currencyValTo}
                              // onChange={(e) => handleCurrencyValTo(e)}
                              className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full max-w-[7.5rem] rounded-lg border py-[0.6875rem] px-4 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                            />
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>

                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton className="flex items-center justify-between w-full px-4 py-2 border-b border-gray-300 focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-50">
                            <span>Traits</span>
                            <svg
                              className={`w-4 h-4 transform transition-transform ${getArrowRotation(
                                0
                              )}`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel className="px-4 py-2">
                          {/* Content for Menu Item 1 */}
                          <div className="accordion" id="accordionProps">
                            <div className="accordion-item dark:border-jacarta-600 border-jacarta-100 border-b">
                              <Accordion>
                                {collectionInfo &&
                                  collectionInfo?.traits &&
                                  Object.entries(
                                    collectionInfo?.traits?.trait_data
                                  ).map((t, k) => {
                                    return (
                                      <AccordionItem key={t}>
                                        <AccordionItemHeading>
                                          <AccordionItemButton>
                                            <h2
                                              className="accordion-header"
                                              id="prop-heading-1"
                                            >
                                              <button className="accordion-button collapsed dark:bg-jacarta-700 font-display text-jacarta-700 relative flex w-full items-center justify-between bg-white px-6 py-5 dark:text-white">
                                                <span>{t[0]}</span>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 24 24"
                                                  width="24"
                                                  height="24"
                                                  className="accordion-arrow fill-jacarta-700 h-4 w-4 transition-transform dark:fill-white"
                                                >
                                                  <path
                                                    fill="none"
                                                    d="M0 0h24v24H0z"
                                                  ></path>
                                                  <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"></path>
                                                </svg>
                                              </button>
                                            </h2>
                                          </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                          <div
                                            id="prop-background"
                                            className="accordion-collapse"
                                          >
                                            {t[1].map((proparty, index) => {
                                              const { name, rarity, point } =
                                                proparty;
                                              return (
                                                <div
                                                  className="accordion-body px-2 pb-4"
                                                  key={index}
                                                >
                                                  <div className="flex flex-col">
                                                    <button
                                                      onClick={() => {
                                                        const temp =
                                                          selectedTraits;
                                                        if (
                                                          temp.includes(name)
                                                        ) {
                                                          const filteredArray =
                                                            temp.filter(
                                                              (element) =>
                                                                element !== name
                                                            );
                                                          setSelectedTraits(
                                                            (prevNames) => [
                                                              ...filteredArray,
                                                            ]
                                                          );
                                                        } else {
                                                          temp.push(name);
                                                          setSelectedTraits(
                                                            (prevNames) => [
                                                              ...temp,
                                                            ]
                                                          );
                                                        }
                                                      }}
                                                    >
                                                      <Collection_category_filter_details
                                                        item={selectedTraits}
                                                        name={name}
                                                        rarity={rarity}
                                                      />
                                                    </button>
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </div>
                                        </AccordionItemPanel>
                                      </AccordionItem>
                                    );
                                  })}
                              </Accordion>
                            </div>
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>

                      {/* Add more AccordionItem components as needed for additional menu items */}
                    </Accordion>
                    {/* Dropdown End */}
                  </div>
                  {/* <!-- end body --> */}

                  <div className="modal-footer">
                    <div className="flex items-center justify-center space-x-4">
                      <button
                        type="button"
                        onClick={propertiesFilterAll}
                        className="text-accent shadow-white-volume hover:bg-accent-dark hover:shadow-accent-volume w-36 rounded-full bg-white py-3 px-8 text-center font-semibold transition-all hover:text-white"
                      >
                        Clear All
                      </button>
                      <button
                        type="button"
                        onClick={() => propertiesFilterHandle()}
                        className="bg-accent shadow-accent-volume hover:bg-accent-dark w-36 rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- end properties modal --> */}

            <div
              className="dropdown-menu dark:bg-jacarta-800 z-10 hidden min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl"
              aria-labelledby="propertiesFilter"
            >
              <ul className="flex flex-col flex-wrap">
                <li>
                  <a
                    href="#"
                    className="dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white"
                  >
                    <span className="text-jacarta-700 dark:text-white">
                      All
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      className="fill-accent mb-[3px] h-4 w-4"
                    >
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white"
                  >
                    Art
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white"
                  >
                    Collectibles
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white"
                  >
                    Domain
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white"
                  >
                    Music
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white"
                  >
                    Photography
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white"
                  >
                    Virtual World
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* <!-- Sale Type --> */}
          {/* <Recently_added_dropdown data={saleTypeText} dropdownFor="sale-type" /> */}

          {/* <!-- Price Range --> */}
          {/* <Recently_added_dropdown
            data={saleTypeText}
            dropdownFor="price-range"
          /> */}
          <form
            action="search"
            className="relative  block search_collection_nft"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <input
              type="search"
              className=" text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full rounded-2xl border py-[0.2575rem] px-4 pl-10 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
              placeholder="Search by NFT"
              onChange={(e) => singleNFTSearchInput(e.target.value)}
            />
            <button
              type="submit"
              className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                className="fill-jacarta-500 h-4 w-4 dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z"></path>
              </svg>
            </button>
          </form>
        </div>

        {/* <!-- Sort --> */}
        <div className="flex">
          <Recently_added_dropdown
            data={sortText}
            dropdownFor="recently_added"
          />
          <ToggleBtn />
        </div>
      </div>
    </>
  );
};

export default Collection_category_filter;
